import {Component} from '@angular/core';
import {CHART_TYPE, TUPLA_TYPE} from '../../../DoraData/data-base';
import {DoraColumnSelectorComponent} from '../dora-column-selector.component';

@Component({
  selector: 'dora-column-selector-lb',
  templateUrl: './dora-column-selector-lb.component.html',
  styleUrls: ['./dora-column-selector-lb.component.scss']
})
export class DoraColumnSelectorLbComponent extends DoraColumnSelectorComponent {

  // ChartTypeList
  public columnList: Array<any> = [];
  public selectedItem: Array<any> = [];


  protected onNewData(): void {
    super.onNewData();

    this.columnList = [];
    this.selectedItem = [];
    this.dataGrid.tuplasDescription.filter(x => x.Type === TUPLA_TYPE.NUMBER).forEach(tuplaDescription => {
      // tslint:disable-next-line:max-line-length
      const selectElement = {id: `${tuplaDescription.Id}`, text: `<div class="DAG-img-select" style="width: 10px; height: 10px; background-color: red; display: inline-block;"></div>${tuplaDescription.Name}`};
      // const selectElement = {id: `${chartTypeElement.Type}`, text: `${chartTypeElement.description as string}`};

      this.columnList.push(selectElement);
      this.selectedItem.push(selectElement);

      tuplaDescription.selected = true;
    });

  }

  public selected(value: any): void {
    console.log('Selected value is: ', value);
    this.selectionChanged(value.id, true);

    // let dataRow: DataRow;
    // dataRow = this.dataGrid.getDataRow(value.id);
    //
    // if (dataRow === null) {
    //   console.error('Row not found. Id: ' + value.id);
    //   return;
    // }
    //
    // this.messageService.sendMessage(this.EventChannel, new MessageGridSelected(dataRow.GridId));
  }

  public removed(value: any): void {
    console.log('Removed value is: ', value);
    this.selectionChanged(value.id, false);
  }

  public typed(value: any): void {
    console.log('New search input: ', value);
  }

  public refreshValue(value: any): void {
    console.log('Typed: ', value);
  }

}
